import React from "react";
import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const NetworkReportLayout = () => {
  return (
    <Box p={{ base: 4, md: 6 }} w="100%" maxW="100%" overflowX="hidden">
      <Outlet />
    </Box>
  );
};

export default NetworkReportLayout;
